"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _propTypes = require("prop-types");

var _documents = require("../../constants/documents");

var _FilePdf = _interopRequireDefault(require("../Icons/FilePdf"));

var _Image = _interopRequireDefault(require("../Icons/Image"));

var _FileDocument = _interopRequireDefault(require("../Icons/FileDocument"));

var _FilePresentation = _interopRequireDefault(require("../Icons/FilePresentation"));

var _FileSpreadsheet = _interopRequireDefault(require("../Icons/FileSpreadsheet"));

var _FileText = _interopRequireDefault(require("../Icons/FileText"));

var _FileMovie = _interopRequireDefault(require("../Icons/FileMovie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fileGroupLookup = function fileGroupLookup(fileName) {
  var fileExtension = fileName.split('.').pop();

  var fileTypeMatch = _documents.supportedFileTypes.find(function (fileType) {
    return fileType.extensions.includes(fileExtension);
  });

  return fileTypeMatch ? fileTypeMatch.group : 'unknown';
};

var FileIconGroups = {
  word: _FileDocument.default,
  wordx: _FileDocument.default,
  'oo-doc': _FileDocument.default,
  'oo-gfx': _FileDocument.default,
  pages: _FileDocument.default,
  pdf: _FilePdf.default,
  application: _FilePdf.default,
  excel: _FileSpreadsheet.default,
  'oo-sht': _FileSpreadsheet.default,
  numbers: _FileSpreadsheet.default,
  powerpoint: _FilePresentation.default,
  'oo-pres': _FilePresentation.default,
  keynote: _FilePresentation.default,
  text: _FileText.default,
  movie: _FileMovie.default
};

var displayFileIcon = function displayFileIcon(fileName, color) {
  var Element = FileIconGroups[fileGroupLookup(fileName)] || _Image.default;

  var displayName = Element.displayName;
  return _react.default.createElement(Element, {
    size: 22,
    color: color,
    "data-testid": displayName
  });
};

var FileIcon = function FileIcon(_ref) {
  var fileName = _ref.fileName,
      color = _ref.color;
  return displayFileIcon(fileName, color);
};

FileIcon.propTypes = {
  fileName: _propTypes.string,
  color: _propTypes.string
};
FileIcon.defaultProps = {
  fileName: 'document.png',
  color: _colors.default.link
};
var _default = FileIcon;
exports.default = _default;